
import InputField from '../../../components/InputField/InputField';
import Button from '../../../components/Button/Button';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MultiSelect } from 'react-multi-select-component';

const Settings = ({ isActiveTab, changePassToggler, password, errorPassword, addMentee, errorAddMentee, handleProfileDiscard, handleProfileSave, handleChange, handleDropdownChange, handleUploadProfile, handlePassChange, handlePassChangeConfirm, handlePassPressConfirm, handleShowChangePass, handleCancelChangePass }) => {

    const domainOptions = [
        {
            name: "Management",
            value: "Management",
        },
        {
            name: "Engineering",
            value: "Engineering",
        },
        {
            name: "Arts & Science",
            value: "Arts & Science",
        },
        {
            name: "Others",
            value: "Others",
        },
    ];

    const currentYearOptions = [
        {
            name: "1st Year",
            value: "1",
        },
        {
            name: "2nd Year",
            value: "2",
        },
        {
            name: "3rd Year",
            value: "3",
        },
        {
            name: "4th Year",
            value: "4",
        },
        {
            name: "5th Year",
            value: "5",
        },
    ];

    const yrsOfExpOptions = [
        {
            name: "0-3 years",
            value: "3",
        },
        {
            name: "3-5 years",
            value: "5",
        },
        {
            name: "5-10 years",
            value: "10",
        },
        {
            name: "10+ years",
            value: "50",
        },
    ];

    return (
        <>
            <section className={`tabWrapper ${isActiveTab && 'active'}`}>
                <div className={`ContainerTabForAllTabData allMentorWrapper`}>
                    <div className="Headingforallheader">
                        <div className="flex-between w-100">
                            <h2 className="heading-2">Edit Profile</h2>
                        </div>
                    </div>

                    <div className="border-btm w-100"></div>

                    <div className="bodyDataForallUserdata">
                        <div className="AdMainsetting mt-20  overflow">

                            <div className="userProfileEdit mulipleFormInputWrap">
                                <h4 className='lableHeading'>Avatar</h4>
                                <div className="leftWrapperPrfile mb25">
                                    <div className="userProfileEditTab">
                                        <label className="userProfile pointer" for="bgimg">
                                            <img
                                                src={
                                                    addMentee["profileImg"]
                                                    ? addMentee["profileImg"]
                                                        : "/assets/img/user1.png"
                                                    } 
                                                    alt="" className="userimg" 
                                                    onClick={handleUploadProfile}
                                            />
                                            <img src="/assets/img/edit.png" alt="" className="editimg pointer"
                                            />
                                        </label>
                                    </div>
                                    {/* <p className='mt-10 text2'>File types allowed are: jpg, jpeg, png</p> */}
                                </div>
                            </div>
                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>Full Name <span className={"impRed"}> *</span></h4>
                                <div className="multipleFormInput flex-center">
                                <InputField
                                errorMessage={errorAddMentee["firstName"]}
                                name={"firstName"}
                                value={addMentee["firstName"]}
                                onChange={handleChange}
                                notImp={true}
                                placeholder={"First Name"} />
                                <InputField
                                errorMessage={errorAddMentee["lastName"]}
                                name={"lastName"}
                                value={addMentee["lastName"]}
                                onChange={handleChange}
                                notImp={true}
                                placeholder={"Last Name"} />
                                </div>
                            </div>

                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>Email  <span className={"impRed"}> *</span>
                                </h4>
                                <div className="multipleFormInput flex-center">
                                    <InputField
                                        onChange={handleChange} notImp={true} disabled placeholder={"Input email id"} name={"email"} errorMessage={errorAddMentee["email"]} value={addMentee["email"]}
                                    />
                                </div>
                            </div>

                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>Phone Number </h4>
                                <div className="multipleFormInput flex-center">
                                <InputField 
                                type={"tel"}
                                onChange={handleChange}
                                errorMessage={errorAddMentee["mobileNumber"]}
                                notImp={true}
                                placeholder={"Input contact number"}
                                name={"mobileNumber"}
                                value={addMentee["mobileNumber"]}
                                onKeyDown={(e) =>
                                    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()
                                }
                                />
                                            </div>
                            </div>

                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>Qualification Level</h4>
                                <div className="multipleFormInput flex-center">
                                <select className="customDropdownWrap" name='title' onChange={handleDropdownChange}>
                                    <option className='menuList' defaultChecked value={"work"} selected={addMentee["title"] === "work"} >Work</option>
                                    <option className='menuList' value={"student"} selected={addMentee["title"] === "student"}>Student</option>
                                </select>
                                {errorAddMentee["title"] && <span className='FormError'>{errorAddMentee["title"]}</span>}
                                </div>
                            </div>
                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>{addMentee["title"] === "student" ? "Qualification Domain" : "Professional Domain"}</h4>
                                <div className="multipleFormInput flex-center">
                                    <select
                                        className="customDropdownWrap"
                                        name="company"
                                        onChange={handleDropdownChange}>
                                        <option className="menuList" defaultChecked style={{display:"none"}}>{addMentee["title"] === "student" ? "Select your domain" : "Select the professional domain in which you are working"}</option>
                                        {domainOptions?.map((item, index) => (
                                            <option key={index} className="menuList" value={item?.value} selected={addMentee["company"] === item?.value} >{item?.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="mulipleFormInputWrap flexbox">
                                <h4 className='lableHeading'>{addMentee["title"] === "student" ? "Year of study" : "Working Experience"}</h4>
                                <div className="multipleFormInput flex-center">
                                    <select
                                        className="customDropdownWrap"
                                        name="yrsOfExp"
                                        onChange={handleDropdownChange}>
                                        <option className="menuList">{addMentee["title"] === "student" ? "Select year of Study" : "Select count of years working"}</option>
                                        {(addMentee["title"] === "student" ? currentYearOptions : yrsOfExpOptions)?.map((item, index) => (
                                            <option className="menuList" key={index} value={item?.value} selected={addMentee["yrsOfExp"] === +item?.value} >{item?.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="border-btm w-100"></div>
                            <div className="FooterAddmentors flex flexend">
                                <Button name={'Discard'} className={'buttontext GreyFillButton'} onClick={handleProfileDiscard} />
                                <Button name={'Save Changes'} className="active buttontext BlueFillButton" onClick={handleProfileSave} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className={`ContainerTabForAllTabData mt-30 tabWrapper ${changePassToggler === 1 && 'showItpass '}`}>

                    <div className="Headingforallheader">
                        <div className="w-100">
                            <h2 className="heading-2">Change Password</h2>
                        </div>
                    </div>


                    <div className="border-btm  w-100"> </div>

                    <div className="bodyDataForallUserdata">
                        <div className="Password flex-between mt-30">
                            <h4 className='Passwordtext'>Password
                                <span className='text-grey6'>*********</span>
                            </h4>
                            <Button className={'BlueFillButton buttontext'} name={'Reset Password'} onClick={handleShowChangePass} />
                        </div>
                    </div>

                </div>

                <div className={`ContainerTabForAllTabData tabWrapper mt-30 ${changePassToggler === 2 && 'showItpass '}`}>

                    <div className="Headingforallheader">
                        <div className="w-100">
                            <h2 className="heading-2">Change Password</h2>
                        </div>
                    </div>

                    <div className="border-btm  w-100"> </div>

                    <div className="bodyDataForallUserdata">
                        <div className="flex-start AdChangePassWrap">
                            <div className="mulipleFormInputWrap">
                                <h4 className='lableHeading mb-10'>Current Password</h4>
                                <div className='w-100'>
                                    <div className="multipleFormInput flex-center">
                                    <InputField type={"password"} notImp={true} name={"password"} value={password["password"]} onChange={handlePassChange} errorMessage={errorPassword["password"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                                    </div>
                                    <p className='text2 mt-12'>Password must be at least 6 character</p>
                                </div>

                            </div>
                            <div className="mulipleFormInputWrap">
                                <h4 className='lableHeading mb-10'>New Password</h4>
                                <div className="multipleFormInput flex-center">
                                    <InputField type={"password"} notImp={true} name={"newPassword"} value={password["newPassword"]} onChange={handlePassChange} errorMessage={errorPassword["newPassword"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                                </div>
                            </div>
                            <div className="mulipleFormInputWrap">
                                <h4 className='lableHeading mb-10'>Confirm Password</h4>
                                <div className="multipleFormInput flex-center">
                                    <InputField type={"password"} notImp={true} name={"confirmPassword"} value={password["confirmPassword"]} onChange={handlePassChange} errorMessage={errorPassword["confirmPassword"]} placeholder={'******'} onKeyDown={handlePassPressConfirm} />
                                </div>
                            </div>
                        </div>
                        <div className="flex mt-40 gap-20">
                            <Button className={'GreyFillButton  buttontext'} name={'Discard'} onClick={handleCancelChangePass} />
                            <Button className={'BlueFillButton buttontext'} name={'Update Password'} onClick={handlePassChangeConfirm} />
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Settings